import React from "react";
import CommonApi from "./home/apis/common";
import CommonUtils from "./home/utility/common-utilities";
import SessionCache from './home/components/routes/session-cache';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false, error: null };
    this.user = SessionCache.getUser()
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidMount() {
    
  }

  componentDidCatch(error, errorInfo) {
    console.error("UI Error:", error, errorInfo);

    // Send to logger
    //     window.logError?.({
    //       type: "UI_ERROR",
    //       message: error.message,
    //       stack: error.stack,
    //       info: errorInfo
    //     });

    if (CommonUtils.isOnline()) {
      let payload = {
        type: "UI_ERROR",
        message: error.message,
        stack: error.stack,
        info: errorInfo
      }
      CommonApi.sendErrorLogs(payload).then(res => {
        console.log(res)
      })
    }

  }

  handleContinue = () => {
    // Reload current screen
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20 }}>
          <h3>Something went wrong.</h3>
          {/* <p>Please restart the application.</p> */}
          <button className="cursor-pointer" onClick={this.handleContinue}>
            Continue
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
